
import { NavigationItem } from '../shared/types/navigation.types'

const KEYWORDS_LOCALIZED =  $localize`:Navigation Bar Item |Lable displayed in navigation bar item@@NavigationBarItemKeywords:Keywords`;

export const KEYWORDS_ROUTE: NavigationItem = {
    id: 'keywords_route',
    title: KEYWORDS_LOCALIZED,
    type: 'basic',
    icon: '',
    link: '/home',
    requiredRoles: []
}

/**
 * Exports the navigation routes as an array, in the order they should appear inside the app
 */
export const NAVIGATION = [KEYWORDS_ROUTE]
